import { FC, memo, ReactElement } from 'react';

import {
  OuterWrapper,
  AspectRatioMain,
  AspectRatioInner,
} from './styles';

interface AspectRatioProps {
  ratio: number;
  maxWidth?: number | string;
  children: ReactElement,
  className?: string;
}

const AspectRatio: FC<AspectRatioProps> = ({
  children,
  ratio,
  maxWidth,
  className,
}) => (
  <OuterWrapper className={className} maxWidth={maxWidth}>
    <AspectRatioMain ratio={ratio}>
      <AspectRatioInner>
        {children}
      </AspectRatioInner>
    </AspectRatioMain>
  </OuterWrapper>
);

export default memo(AspectRatio);
import { FC, memo, ReactElement } from 'react';

import {
  OuterWrapper,
  AspectRatioMain,
  AspectRatioInner,
} from './styles';

interface AspectRatioProps {
  ratio: number;
  maxWidth?: number | string;
  children: ReactElement,
  className?: string;
}

const AspectRatio: FC<AspectRatioProps> = ({
  children,
  ratio,
  maxWidth,
  className,
}) => (
  <OuterWrapper className={className} maxWidth={maxWidth}>
    <AspectRatioMain ratio={ratio}>
      <AspectRatioInner>
        {children}
      </AspectRatioInner>
    </AspectRatioMain>
  </OuterWrapper>
);

export default memo(AspectRatio);
